import React from 'lib/react';
import {
  EVGrid,
  EVTypography,
  EVExitToAppOutlinedIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import useMediaQuery from 'hooks/useMediaQuery';
import { signOutUser, isAuthorized } from 'utils/auth.utils';
import { PLACE_ORDER_ROUTE } from 'constants/RouteConstants';
import { useLocation } from 'lib/router';
import HeaderStyles from '../HeaderStyles';
import EVLogoButton from './EVLogoButton.component';
import HeaderNav from './HeaderNav.component';
import LogInButton from './LogInButton.component';
import SidebarLogInButton from './SidebarLogInButton.component';
/**
 * Component that renders the menu items in Header or in Sidebar based on screen width.
 */
function MenuItems({ setMenuOpen }) {
  const classes = HeaderStyles();
  const isMobile = useMediaQuery(640);
  const isTablet = useMediaQuery(1024);

  // #genai - Header currently exposes only the translated logout action.
  const { t } = useTranslation();

  const isSidebar = isMobile || isTablet;
  const handleSidebarClose = () => isSidebar && setMenuOpen(false);

  const { pathname } = useLocation();

  const navComponent = () => {
    if (!isAuthorized() && pathname === PLACE_ORDER_ROUTE) return isSidebar ? <SidebarLogInButton /> : <LogInButton />;

    return <HeaderNav handleSidebarClose={handleSidebarClose} />;
  };
  const getSidebarLogoutButton = () => (
    isAuthorized() && (
    <EVGrid
      container
      id="signOut"
      className={classes.signOut}
      onClick={() => {
        handleSidebarClose();
        signOutUser();
      }}
      component="button"
      aria-label={t('LogOut')}
    >
      <EVExitToAppOutlinedIcon />
      <EVTypography classes={{ root: classes.signOutText }}>{t('LogOut')}</EVTypography>
    </EVGrid>
    )
  );

  return (
    <>
      { (isMobile || !isTablet) && (
      <EVLogoButton />
      ) }
      {navComponent()}
      { isSidebar && getSidebarLogoutButton()}
    </>
  );
}

MenuItems.defaultProps = {
  setMenuOpen: () => {},
};

MenuItems.propTypes = {
  setMenuOpen: PropTypes.func,
};

export default MenuItems;
